var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.60095 24.2L21.8043 2.24828L20.3956 0.951782L-1.00098 24.2L20.3956 47.4483L21.8043 46.1518L1.60095 24.2Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.60095 24.2L21.8043 2.24828L20.3956 0.951782L-1.00098 24.2L20.3956 47.4483L21.8043 46.1518L1.60095 24.2Z","key":1})]);
}

Arrow.defaultProps = {"width":"24","height":"48","viewBox":"0 0 22 48","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
